import {searchModel} from "../../../../Utilities/Search";

export const braillerLoanSearchModel = (viewType = "", searchKeyword = "", startDate = "", endDate = "", districtId = "", organization = "") => {
    return Object.assign({}, searchModel(viewType.toString(), "searchKeyword", false, "dateCheckedOut"), {
        viewType,
        searchKeyword,
        startDate,
        endDate,
        districtId,
        organization,
        ClearOrderSearch: clearOrderSearch,
    });
};

function clearOrderSearch(this: Record<string, unknown>) {
    this.viewType = "";
    this.searchKeyword = "";
    this.startDate = "";
    this.endDate = "";
    this.districtId = "";
    this.organization = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}
